import React, { useContext, useState, useCallback, useEffect } from 'react';
import ModalContext from '../../../../contexts/ModalContext';
import cross from '../../../../assets/addStockModal/cross.svg';
// Importe styled-components ou crie componentes para as tags/chips
import { ActionsDiv, AddOPS, CancelButton, CloseDiv, CloseImg, Container, HeaderDiv, HeaderText, InfoText, MachineDiv, OPDiv, Select, SelectedOPContainer, SelectedOPTag, RemoveTagButton } from './style';
import FashionApiService from '../../../../services/FashionApiService';
import { useNavigate } from 'react-router-dom';

// Importe as interfaces dos seus tipos de API
interface Machine {
    id: number;
    identification: string;
}

interface FashionOrder {
    id: number;
    orderNumber: string; // Ex: "OP0001"
    set?: string;
}

// Using FashionApiService for backend calls

// --- NOVOS COMPONENTES ESTILIZADOS PARA AS TAGS/CHIPS ---
// Você precisará definir esses no seu arquivo './style.ts'
// Exemplo (adapte conforme seu sistema de estilo - styled-components, tailwind etc.):
// import styled from 'styled-components';
// export const SelectedOPContainer = styled.div`
//     display: flex;
//     flex-wrap: wrap;
//     gap: 8px;
//     margin-top: 10px;
//     padding: 5px;
//     border: 1px solid #e0e0e0;
//     border-radius: 4px;
//     min-height: 40px;
//     align-items: center;
// `;
// export const SelectedOPTag = styled.div`
//     display: flex;
//     align-items: center;
//     background-color: #e0e0e0;
//     padding: 5px 10px;
//     border-radius: 20px;
//     font-size: 0.9em;
//     cursor: default;
// `;
// export const RemoveTagButton = styled.button`
//     background: none;
//     border: none;
//     color: #555;
//     font-weight: bold;
//     margin-left: 8px;
//     cursor: pointer;
//     &:hover {
//         color: #000;
//     }
// `;
// --- FIM DOS NOVOS COMPONENTES ESTILIZADOS ---


const AddFashionOP = () => {
    const { setModalActive } = useContext(ModalContext);

    // --- Estados para Máquinas ---
    const [machines, setMachines] = useState<Machine[]>([]);
    const [selectedMachineId, setSelectedMachineId] = useState<number | null>(null);
    const [isLoadingMachines, setIsLoadingMachines] = useState(true);
    const [errorMachines, setErrorMachines] = useState<string | null>(null);

    // --- Estados para Ordens de Pedido (OPs) ---
    const [fashionOrders, setFashionOrders] = useState<FashionOrder[]>([]);
    const [selectedFashionOrderId, setSelectedFashionOrderId] = useState<number | null>(null);
    const [isLoadingFashionOrders, setIsLoadingFashionOrders] = useState(true);
    const [errorFashionOrders, setErrorFashionOrders] = useState<string | null>(null);

    // --- NOVO ESTADO: Array para armazenar as OPs selecionadas ---
    const [selectedOPs, setSelectedOPs] = useState<FashionOrder[]>([]);
    const navigate = useNavigate()

    // --- Funções para buscar Máquinas e OPs (mantidas) ---
    const fetchMachines = useCallback(async () => {
        setIsLoadingMachines(true);
        setErrorMachines(null);
        try {
                const response = await FashionApiService.get('/machines');
                setMachines(response.data);
        } catch (err: any) {
            console.error('Erro ao buscar máquinas:', err);
            setErrorMachines('Não foi possível carregar as máquinas.');
        } finally {
            setIsLoadingMachines(false);
        }
    }, []);

    const fetchFashionOrders = useCallback(async () => {
        setIsLoadingFashionOrders(true);
        setErrorFashionOrders(null);
        try {
            const response = await FashionApiService.getProductionOrders();
            setFashionOrders(response.data);
        } catch (err: any) {
            console.error('Erro ao buscar ordens de pedido:', err);
            setErrorFashionOrders('Não foi possível carregar as OPs.');
        } finally {
            setIsLoadingFashionOrders(false);
        }
    }, []);

    useEffect(() => {
        fetchMachines();
        fetchFashionOrders();
    }, [fetchMachines, fetchFashionOrders]);

    // --- Funções para lidar com a mudança nos selects ---
    const handleMachineChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setSelectedMachineId(value === '' ? null : Number(value));
    };

    const handleFashionOrderChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        const newSelectedId = value === '' ? null : Number(value);
        setSelectedFashionOrderId(newSelectedId);

        // --- NOVA LÓGICA: Adicionar a OP selecionada ao array `selectedOPs` ---
        if (newSelectedId !== null) {
            const opToAdd = fashionOrders.find(op => op.id === newSelectedId);
            if (opToAdd && !selectedOPs.some(op => op.id === opToAdd.id)) { // Verifica se já não foi adicionada
                setSelectedOPs(prevOPs => [...prevOPs, opToAdd]);
                // Opcional: Resetar o select para o placeholder após adicionar
                // setSelectedFashionOrderId(null);
            }
        }
    };

    // --- NOVA FUNÇÃO: Remover OP do array `selectedOPs` ---
    const handleRemoveOP = (opIdToRemove: number) => {
        setSelectedOPs(prevOPs => prevOPs.filter(op => op.id !== opIdToRemove));
    };

    // --- Lógica para adicionar OPs (vai usar selectedOPs) ---
    const handleAddOPs = () => {
        // Aqui você faria a requisição POST para associar TODAS as OPs de `selectedOPs` à máquina `selectedMachineId`
        // setModalActive(false); // Fechar modal após adicionar
    };

    // --- Determina se o botão de adicionar deve ser desabilitado ---
    const isAddButtonDisabled = isLoadingMachines || isLoadingFashionOrders ||
                                selectedMachineId === null || selectedOPs.length === 0; // Botão habilitado se máquina selecionada e pelo menos uma OP adicionada

    return (
        <Container>
            <HeaderDiv>
                <HeaderText>Adicionar OP</HeaderText>
                <CloseDiv onClick={() => navigate(-1)}>
                    <CloseImg src={cross} alt='Fechar aba' />
                </CloseDiv>
            </HeaderDiv>

            <MachineDiv>
                <InfoText>Máquina</InfoText>
                <Select
                    name="machineSelect"
                    id="machine-select"
                    value={selectedMachineId !== null ? selectedMachineId : ''}
                    onChange={handleMachineChange}
                    disabled={isLoadingMachines || errorMachines !== null}
                >
                    <option value="" disabled={selectedMachineId !== null}>
                        {isLoadingMachines ? 'Carregando máquinas...' :
                         errorMachines ? `Erro: ${errorMachines}` :
                         machines.length === 0 ? 'Nenhuma máquina encontrada' :
                         'Selecione a Máquina'}
                    </option>
                    {!isLoadingMachines && !errorMachines && machines.length > 0 && (
                        machines.map(machine => (
                            <option key={machine.id} value={machine.id}>
                                {machine.identification}
                            </option>
                        ))
                    )}
                </Select>
            </MachineDiv>

            <OPDiv>
                <InfoText>Selecionar OP</InfoText>
                <Select
                    name="opSelect"
                    id="op-select"
                    value={selectedFashionOrderId !== null ? selectedFashionOrderId : ''}
                    onChange={handleFashionOrderChange}
                    disabled={isLoadingFashionOrders || errorFashionOrders !== null}
                >
                    <option value="" disabled={selectedFashionOrderId !== null}>
                        {isLoadingFashionOrders ? 'Carregando OPs...' :
                         errorFashionOrders ? `Erro: ${errorFashionOrders}` :
                         fashionOrders.length === 0 ? 'Nenhuma OP encontrada' :
                         'Selecione a OP'}
                    </option>
                    {!isLoadingFashionOrders && !errorFashionOrders && fashionOrders.length > 0 && (
                        // Filtra as OPs que JÁ FORAM SELECIONADAS para não aparecerem novamente no dropdown
                        fashionOrders
                            .filter(order => !selectedOPs.some(selected => selected.id === order.id))
                            .map(order => (
                                <option key={order.id} value={order.id}>
                                    OP - {order.id} {order.set ? ` - ${order.set}` : ''}
                                </option>
                            ))
                    )}
                </Select>
                
                {/* --- NOVO: Área para exibir as OPs selecionadas como tags --- */}
                {selectedOPs.length > 0 && (
                    <SelectedOPContainer>
                        {selectedOPs.map(op => (
                            <SelectedOPTag key={op.id}>
                                {op.orderNumber || `OP - ${op.id}`} {/* Exibe o orderNumber ou fallback */}
                                <RemoveTagButton onClick={() => handleRemoveOP(op.id)}>X</RemoveTagButton>
                            </SelectedOPTag>
                        ))}
                    </SelectedOPContainer>
                )}
                {/* --- FIM: Área para exibir as OPs selecionadas como tags --- */}
            </OPDiv>

            <ActionsDiv>
                <CancelButton onClick={() => navigate(-1)}>Cancelar</CancelButton>
                <AddOPS
                    onClick={handleAddOPs}
                    disabled={isAddButtonDisabled} // Usa a nova variável de desabilitação
                >
                    + Adicionar OPs
                </AddOPS>
            </ActionsDiv>
        </Container>
    );
};

export default AddFashionOP;
